import { createFileRoute, Link } from "@tanstack/react-router";
import { useState } from "react";
import { z } from "zod";
import { AuthLayout } from "../components/auth-layout";
import { Button } from "../components/ui/button";
import { FieldError, Input, Label } from "../components/ui/input";
import { authClient } from "../lib/auth";

export const Route = createFileRoute("/reset-password")({
  validateSearch: z.object({ token: z.string().optional(), error: z.string().optional() }),
  component: ResetPassword,
});

function ResetPassword() {
  const { token, error: linkError } = Route.useSearch();
  const [error, setError] = useState<string>();
  const [done, setDone] = useState(false);
  if (!token || linkError) {
    return (
      <AuthLayout title="Link invalid">
        <p className="text-sm">This reset link is invalid or has expired.</p>
        <Link to="/forgot-password" className="mt-4 block text-sm text-primary hover:underline">
          Request a new one
        </Link>
      </AuthLayout>
    );
  }
  return (
    <AuthLayout title="Choose a new password">
      {done ? (
        <p className="text-sm">
          Password changed.{" "}
          <Link to="/login" className="text-primary hover:underline">
            Sign in
          </Link>
        </p>
      ) : (
        <form
          className="flex flex-col gap-4"
          onSubmit={async (e) => {
            e.preventDefault();
            const newPassword = String(new FormData(e.currentTarget).get("password"));
            const { error } = await authClient.resetPassword({ newPassword, token });
            if (error) return setError(error.message ?? "Could not reset password");
            setDone(true);
          }}
        >
          <div className="flex flex-col gap-2">
            <Label htmlFor="password">New password (min. 10 characters)</Label>
            <Input
              id="password"
              name="password"
              type="password"
              minLength={10}
              autoComplete="new-password"
              required
            />
          </div>
          <FieldError>{error}</FieldError>
          <Button type="submit">Save password</Button>
        </form>
      )}
    </AuthLayout>
  );
}
